import { Package } from 'lucide-react';
import type { ReactElement } from 'react';

interface ReviewTargetCardProps {
  readonly productName: string;
  /** 견적 디자인 썸네일 — 아직 그려지지 않았거나 모르면 null(상자 아이콘 자리표시). */
  readonly thumbnailUrl: string | null;
  /** "네이비 · 실크 · 300개" 같은 구매 정보 한 줄. */
  readonly detail: string | null;
}

/** 후기 쓰기·수정 화면 오른쪽의 "후기를 남길 상품" 카드 — 큰 화면에서는 스크롤을 따라온다. */
export const ReviewTargetCard = ({
  productName,
  thumbnailUrl,
  detail,
}: ReviewTargetCardProps): ReactElement => (
  <aside
    aria-label="후기를 남길 상품"
    className="flex items-center gap-5 rounded-2xl bg-muted/60 p-5 lg:sticky lg:top-28 lg:flex-col lg:items-stretch"
  >
    <div className="size-24 shrink-0 overflow-hidden rounded-xl bg-background lg:aspect-square lg:size-auto">
      {thumbnailUrl === null ? (
        <div className="grid size-full place-items-center text-muted-foreground">
          <Package aria-hidden className="size-8" />
        </div>
      ) : (
        <img src={thumbnailUrl} alt="" className="size-full object-contain" />
      )}
    </div>
    <div className="flex min-w-0 flex-col gap-1.5">
      <p className="text-xs text-muted-foreground">후기를 남길 상품</p>
      <p className="text-lg leading-snug font-semibold tracking-[-0.01em] wrap-anywhere">
        {productName}
      </p>
      {detail !== null && <p className="text-sm text-muted-foreground">{detail}</p>}
    </div>
  </aside>
);
